import React from "react";
import { Link } from "react-router-dom";
import { useNav } from "../context/NavContext";

function Header() {
  const { openMobile, headerMode } = useNav();

  return (
    <div className={`main-header is-header-${headerMode}`}>
      <div className="topbar-one">
        <div className="container-fluid">
          <div className="topbar-one__inner">
            <ul className="list-unstyled topbar-one__info">
              <li className="topbar-one__info__item">
                <i className="fas fa-map-marker topbar-one__info__icon"></i>
                <span>
                  No. 108, Richmond Hill Residencies, Thapodarama Road,
                  Hanthana, Kandy
                </span>
              </li>
              <li className="topbar-one__info__item">
                <i className="fas fa-envelope topbar-one__info__icon"></i>
                <a href="mailto:hanthanahouse@gmail.com">
                  hanthanahouse@gmail.com
                </a>
              </li>
              <li className="topbar-one__info__item">
                <i className="fas fa-phone-square topbar-one__info__icon"></i>
                <a href="tel:+94812218625">+94 (81) 221 8625</a>
              </li>
              <li className="topbar-one__info__item">
                <i className="fas fa-phone-square topbar-one__info__icon"></i>
                <a href="tel:+94777374560">+94 (77) 737 4560</a>
              </li>
            </ul>
            <div className="topbar-one__right">
              <div className="topbar-one__social">
                <a href="https://web.facebook.com/hanthanahouse">
                  <i className="fab fa-facebook"></i>
                </a>
                <a href="https://www.instagram.com/hanthanahousekandy/">
                  <i className="fab fa-instagram"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <header className="main-header__bottom sticky-header sticky-header--normal">
        <div className="container-fluid">
          <div className="main-header__logo">
            <Link to="/">
              <img
                src="/assets/images/logo/logo.webp?v=20260924"
                className="nav_logo"
                alt="Hanthana House"
              />
            </Link>
          </div>
          <nav className="main-header__nav main-menu">
            <ul className="main-menu__list">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">Our Story</Link>
              </li>
              <li className="dropdown">
                <Link to="/rooms">Our Rooms</Link>
                <ul>
                  <li>
                    <Link to="/peakroom">The Peak</Link>
                  </li>
                  <li>
                    <Link to="/peakfamily">The Peak Family</Link>
                  </li>
                  <li>
                    <Link to="/foresttriple">Forest View Triple Room</Link>
                  </li>
                  <li>
                    <Link to="/forestdouble">Forest View Double Room</Link>
                  </li>
                  <li>
                    <Link to="/foresttwin">Forest View Twin Room</Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="/gallery">Browse the Gallery</Link>
              </li>
              <li className="dropdown">
                <Link to="/experiences">Experiences</Link>
                <ul>
                  <li>
                    <Link to="/cookingclass">Sri Lankan Cooking Class</Link>
                  </li>
                  <li>
                    <Link to="/teafactoryvisits">Tea Factories & Estates</Link>
                  </li>
                  <li>
                    <Link to="/hanthanarange">Hanthana Range Hiking</Link>
                  </li>
                  <li>
                    <Link to="/pekoe">The Pekoe Trail</Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="/contact">Reach Out to Us</Link>
              </li>
            </ul>
          </nav>
          <div className="main-header__right">
            <button
              type="button"
              className="mobile-nav__btn mobile-nav__toggler"
              aria-label="Open menu"
              onClick={openMobile}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
            <Link
              to="/contact"
              className="villoz-btn villoz-btn--border main-header__btn"
            >
              <i>Stay With Us</i>
              <span>Stay With Us</span>
            </Link>
          </div>
        </div>
      </header>
    </div>
  );
}

export default Header;
